<script lang="ts" module>
  export type IconName =
    | 'upload'
    | 'lock'
    | 'check'
    | 'doc'
    | 'sliders'
    | 'chevron'
    | 'page'
    | 'text'
    | 'structure'
    | 'image'
    | 'book'
    | 'sparkle'
    | 'download'
    | 'x'
    | 'wifi-off'
    | 'shield'
    | 'edit'
    | 'link';
</script>

<script lang="ts">
  let { name, size = 20 }: { name: IconName; size?: number } = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  stroke="currentColor"
  stroke-width="1.8"
  stroke-linecap="round"
  stroke-linejoin="round"
  aria-hidden="true"
>
  {#if name === 'upload'}
    <path d="M12 15.5V4m0 0L7.5 8.5M12 4l4.5 4.5" /><path d="M4 14.5v3.5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3.5" />
  {:else if name === 'lock'}
    <rect x="5" y="10.5" width="14" height="9.5" rx="2" /><path d="M8 10.5V8a4 4 0 0 1 8 0v2.5" />
  {:else if name === 'check'}
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  {:else if name === 'doc'}
    <path d="M7 3h7l5 5v11a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2z" /><path d="M14 3v5h5" /><path d="M9 13h6M9 17h4" />
  {:else if name === 'sliders'}
    <path d="M4 7h9M17 7h3M4 17h3M11 17h9" /><circle cx="15" cy="7" r="2" /><circle cx="9" cy="17" r="2" />
  {:else if name === 'chevron'}
    <path d="M9 6l6 6-6 6" />
  {:else if name === 'page'}
    <rect x="5" y="3" width="14" height="18" rx="2" /><path d="M5 7.5h14M9.5 3v18" stroke-dasharray="2 2" />
  {:else if name === 'text'}
    <path d="M5 6h14M5 10h14M5 14h14M5 18h9" />
  {:else if name === 'structure'}
    <path d="M4 5.5h9M8 12h12M8 18.5h12M4 5.5v13M4 12h4M4 18.5h4" />
  {:else if name === 'image'}
    <rect x="3.5" y="5" width="17" height="14" rx="2" /><circle cx="9" cy="10" r="1.6" /><path d="M20.5 15.5l-5-5-8.5 8.5" />
  {:else if name === 'book'}
    <path d="M5 4.5A1.5 1.5 0 0 1 6.5 3H19v15H6.5A1.5 1.5 0 0 0 5 19.5v-15z" /><path d="M5 19.5A1.5 1.5 0 0 0 6.5 21H19" /><path d="M9 7.5h6" />
  {:else if name === 'sparkle'}
    <path d="M12 3.5l1.9 5 5.1 1.9-5.1 1.9-1.9 5.2-1.9-5.2L5 10.4l5.1-1.9z" /><path d="M18.5 16v4M16.5 18h4" />
  {:else if name === 'download'}
    <path d="M12 4v11.5m0 0L7.5 11M12 15.5l4.5-4.5" /><path d="M4 17.5v.5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-.5" />
  {:else if name === 'x'}
    <path d="M6 6l12 12M18 6L6 18" />
  {:else if name === 'wifi-off'}
    <path d="M3 3l18 18" /><path d="M8.6 16.2a5 5 0 0 1 6.8 0M5.2 12.7a10 10 0 0 1 4.9-2.6M14 10.2a10 10 0 0 1 4.8 2.5M2 9.3a15 15 0 0 1 4.2-2.8M10.8 5a15 15 0 0 1 11.2 4.3" /><circle cx="12" cy="19.5" r=".8" />
  {:else if name === 'shield'}
    <path d="M12 3l7 3v5.2c0 4.7-3.2 8.2-7 9.8-3.8-1.6-7-5.1-7-9.8V6z" /><path d="M9 12l2.2 2.2L15.5 10" />
  {:else if name === 'edit'}
    <path d="M4 20h4L19 9l-4-4L4 16v4z" /><path d="M13.5 6.5l4 4" />
  {:else if name === 'link'}
    <path d="M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1" /><path d="M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1" />
  {/if}
</svg>
